import { type DefaultConfig } from '@/offers/tenant-config/tenants/default-config';
import { TENANT } from '@/utils/helpers';

const tenants = Object.keys(import.meta.glob('./tenants/*.ts')).map((key) =>
  key.replace('./tenants/', '').replace('.ts', '')
);

const tenant = TENANT && tenants.includes(TENANT) ? TENANT : null;

export let config: DefaultConfig;

export const loadConfig = async () => {
  if (config) return;

  const configToLoad = tenant || 'default-config';

  try {
    const res = await import(`./tenants/${configToLoad}.ts`);

    if (configToLoad === 'default-config') {
      config = res.defaultConfig;
      return;
    }

    config = res.config;
  } catch (error) {
    console.error(`There was an error loading the ${configToLoad} config file.`);

    throw error;
  }
};
